import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminAddons = lazy(() => import("@/pages/admin/AdminAddons"));

export const Route = createFileRoute("/admin/addons")({
  component: AdminAddons,
});
